
export default {
  Id: "Id",
  "-Id": "Id",
  "CompanyName,Id": "Name",
  "-CompanyName,Id": "Name",
  "City,Id": "City",
  "-City,Id": "City",
  "State,Id": "State",
  "-State,Id": "State",
  "Zip,Id": "Zip",
  "-Zip,Id": "Zip",
  "SalesRepName,Id": "Rep",
  "-SalesRepName,Id": "Rep",
  "TerritoryName,Id": "Territory",
  "-TerritoryName,Id": "Territory",
  "RegionName,Id": "Region",
  "-RegionName,Id": "Region",
  "Status,CompanyName,Id": "Status",
  "-Status,CompanyName,Id": "Status"
};